import{interpolateString as n}from"../strings/index.js";var r=function(r){var o,i,s=r||"app",e=null!==(o=process.env.NEXT_PUBLIC_APPLICANT_PORTAL_BASE_URL)&&void 0!==o?o:"";return null!==(i=n(e,{subDomain:s}))&&void 0!==i?i:""};export{r as getNextPublicApplicantPortalBaseURL};
//# sourceMappingURL=index.js.map
